import React, { createContext, useContext, useState } from 'react';

type TabType = 'details' | 'activities' | 'tasks' | 'belongings' | 'feeding' | 'meds';

interface OrderDetailContextValue {
    activeTab: TabType;
    setActiveTab: (tab: TabType) => void;
}

const OrderDetailContext = createContext<OrderDetailContextValue | undefined>(undefined);

interface OrderDetailProviderProps {
    children: React.ReactNode;
}

export const OrderDetailProvider: React.FC<OrderDetailProviderProps> = ({ children }) => {
    const [activeTab, setActiveTab] = useState<TabType>('details');

    const value: OrderDetailContextValue = {
        activeTab,
        setActiveTab
    };

    return <OrderDetailContext.Provider value={value}>{children}</OrderDetailContext.Provider>;
};

export const useOrderDetailContext = (): OrderDetailContextValue => {
    const context = useContext(OrderDetailContext);
    if (context === undefined) {
        throw new Error('useOrderDetailContext must be used within an OrderDetailProvider');
    }
    return context;
};
